import React from 'react';
import { SECTION_NAV_GROUP, SUB_MODULES, NAV_GROUP_COLORS, NAV_GROUP_TAB_CLASS, SECTION_TITLES } from '../config.jsx';
import { SyncIndicator } from './auth.jsx';

// =============================================
// TOP BAR COMPONENT
// =============================================
export function TopBar({ activeSection, activeModule, onModuleChange, goldCount, loanCount, syncStatus, lastSynced, onSyncNow, isOnline, baseCurrencyLabel, syncStuck, onForceReconnect }) {
    const navGroup = SECTION_NAV_GROUP[activeSection] || 'home';
    const subModules = SUB_MODULES[activeSection];
    const accentColor = NAV_GROUP_COLORS[navGroup] || '#FFD700';
    const tabActiveClass = NAV_GROUP_TAB_CLASS[navGroup] || '';
    const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

    // For wealth: the "active" sub-tab is determined by activeModule,
    // but its parent section may differ from activeSection.
    const isSubTabActive = (tab) => {
        if (tab.section) {
            // active when section matches AND module matches
            return tab.section === activeSection && tab.id === activeModule;
        }
        return tab.id === activeModule;
    };

    const closeMobileMenu = () => setIsMobileMenuOpen(false);

    return (
        <>
            <div className="top-bar-wrapper">
                <div className="top-bar-row1">
                    <div className="top-bar-logo">
                        <span className="top-bar-logo-text">iPlanner</span>
                        <div className="top-bar-chips">
                            <span className="stat-chip">
                                <span className="stat-chip-dot"></span>
                                {goldCount} Gold
                            </span>
                            <span className="stat-chip">
                                <span className="stat-chip-dot"></span>
                                {loanCount} Loans
                            </span>
                            <span className="stat-chip" style={{ background: 'rgba(255,215,0,0.06)', borderColor: 'rgba(255,215,0,0.2)' }}>
                                {baseCurrencyLabel}
                            </span>
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <div className="top-bar-chips">
                            <SyncIndicator
                                syncStatus={isOnline ? syncStatus : 'offline'}
                                lastSynced={lastSynced}
                                onSyncNow={onSyncNow}
                                isOnline={isOnline}
                                syncStuck={syncStuck}
                                onForceReconnect={onForceReconnect}
                            />
                        </div>
                        <span className="top-bar-page-title">{SECTION_TITLES[activeSection]}</span>
                        <button
                            className="hamburger-btn"
                            onClick={() => setIsMobileMenuOpen(true)}
                            aria-label="Open menu"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="3" y1="6" x2="21" y2="6"></line>
                                <line x1="3" y1="12" x2="21" y2="12"></line>
                                <line x1="3" y1="18" x2="21" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                </div>
                {subModules && (
                    <div className="top-bar-row2">
                        {subModules.map(m => (
                            <button
                                key={m.id}
                                className={`sub-nav-tab ${isSubTabActive(m) ? `active ${tabActiveClass}` : ''}`}
                                style={isSubTabActive(m) ? { color: accentColor, borderBottomColor: accentColor } : {}}
                                onClick={() => onModuleChange(m.id, m.section)}
                            >
                                {m.label}
                            </button>
                        ))}
                    </div>
                )}
            </div>

            {/* Mobile Menu Overlay */}
            <div
                className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}
                onClick={closeMobileMenu}
            />

            {/* Mobile Menu Slide-out */}
            <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
                <div className="mobile-menu-header">
                    <span className="mobile-menu-title">iPlanner</span>
                    <button className="mobile-menu-close" onClick={closeMobileMenu} aria-label="Close menu">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>
                <div className="mobile-menu-content">
                    <div className="mobile-menu-page-title">
                        {SECTION_TITLES[activeSection]}
                    </div>
                    <div className="mobile-menu-section">
                        <span className="mobile-menu-label">Statistics</span>
                        <div className="mobile-menu-chips">
                            <span className="stat-chip">
                                <span className="stat-chip-dot"></span>
                                {goldCount} Gold
                            </span>
                            <span className="stat-chip">
                                <span className="stat-chip-dot"></span>
                                {loanCount} Loans
                            </span>
                            <span className="stat-chip" style={{ background: 'rgba(255,215,0,0.06)', borderColor: 'rgba(255,215,0,0.2)' }}>
                                {baseCurrencyLabel}
                            </span>
                        </div>
                    </div>
                    <div className="mobile-menu-section">
                        <span className="mobile-menu-label">Sync Status</span>
                        <div className="mobile-menu-sync" onClick={() => { onSyncNow(); closeMobileMenu(); }}>
                            <SyncIndicator
                                syncStatus={isOnline ? syncStatus : 'offline'}
                                lastSynced={lastSynced}
                                onSyncNow={() => { }}
                                isOnline={isOnline}
                                syncStuck={syncStuck}
                                onForceReconnect={onForceReconnect}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}